import { SEGMENTS_TO_HIDE_PERSONAL_WORKSPACE_NUDGE } from "constants/personal-workspace-nudge";

/* Hide nudge on certain flows */
export const shouldHidePersonalWorkspaceNudgeForPath = (pathname: string): boolean => {
  if (!pathname) return false;
  const p = pathname.toLowerCase();
  return SEGMENTS_TO_HIDE_PERSONAL_WORKSPACE_NUDGE.some((s) => p.includes(s));
};
